<p>Restock Held Inventory</p>
<form [formGroup]="itemForm">
    <mat-form-field style="width:180px;" appearance="fill">
        <mat-label>Item</mat-label>
        <input matInput #inventoryID scanInput="ITM" formControlName="inventoryID" autofocus
            (scanned)="onItemEntered($event)" />
        <button mat-icon-button matSuffix type="button" (click)="itemFormReset()">
            <mat-icon>cancel</mat-icon>
        </button>
    </mat-form-field>

    <input type="hidden" #inventoryID scanInput="LOT" formControlName="lotSerialNbr"
        (scanned)="onLotNumberEntered($event)" />
</form>

<table>
    <thead>
        <tr>
            <td><!-- selected --></td>
            <td>Inventory ID</td>
            <td>Lot/Serial #</td>
            <td>Qty</td>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of heldItems">
            <td style="min-width:14px;">
                <div *ngIf="item.selected">✔</div>
            </td>
            <td>{{item.InventoryID}}</td>
            <td>{{item.LotSerialNbr}}</td>
            <td>{{item.AdjQtyAvailable}}</td>
        </tr>
    </tbody>
</table>

<mat-dialog-actions style="display:flex; justify-content: space-between;">
    <button mat-raised-button (click)="selectAllRemaining()" color="accent">✔ Remaining</button>
    <span></span>
    <button mat-raised-button (click)="close()" color="primary">Close</button>
</mat-dialog-actions>